module.exports = __webpack_public_path__ + "fonts/ebebb4b.ttf";